"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _I18n = _interopRequireDefault(require("I18n"));

var _underscore = require("../../utils/underscore");

var _react = _interopRequireWildcard(require("react"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _Functions = require("../../core/Functions");

var BLANK_REGEX = /^\s*$/;
var PERCENTAGE_REGEX = /%$/;
var NUMBER_TYPES = {
  DECIMAL: 'decimal',
  PERCENTAGE: 'percentage'
};

function formatPercentage(value) {
  return _I18n.default.formatPercentage(value, {
    precision: value % 1 === 0 ? 0 : 2
  });
}

function parsePercentage(valueToParse) {
  return valueToParse.replace(PERCENTAGE_REGEX, '');
}

var UIAbstractNumberInput = _react.default.createClass({
  displayName: "UIAbstractNumberInput",
  propTypes: {
    children: _react.PropTypes.func.isRequired,
    error: _react.PropTypes.bool,
    formatStyle: _react.PropTypes.oneOf(Object.keys(NUMBER_TYPES).map(function (k) {
      return NUMBER_TYPES[k];
    })),
    formatter: _react.PropTypes.func,
    parser: _react.PropTypes.func,
    onBlur: _react.PropTypes.func,
    onChange: _react.PropTypes.func,
    onFocus: _react.PropTypes.func,
    onKeyUp: _react.PropTypes.func,
    value: _react.PropTypes.number,
    min: _react.PropTypes.number,
    max: _react.PropTypes.number
  },
  getInitialState: function getInitialState() {
    var _this$props = this.props,
        value = _this$props.value,
        formatStyle = _this$props.formatStyle,
        formatter = _this$props.formatter;
    return this.getStateOnValueReset({
      value: value,
      formatStyle: formatStyle,
      formatter: formatter
    });
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _this$props2 = this.props,
        value = _this$props2.value,
        formatStyle = _this$props2.formatStyle,
        formatter = _this$props2.formatter; // Uses this flag to determine if the last change was triggered by the `ESC` key.
    // This logic is separate from the following logic since value and nextProps.value
    // could be equal, and you would still want this reset to trigger. (1000 vs 1,000)

    if (this.escKeyUpTriggered) {
      this.setState(this.getStateOnValueReset({
        value: nextProps.value,
        formatStyle: nextProps.formatStyle,
        formatter: nextProps.formatter
      }));
      this.escKeyUpTriggered = false;
      return;
    } // Ignore changes from one invalid value (NaN) to another


    var valueChanged = value !== nextProps.value && !((0, _underscore.isNaN)(value) && (0, _underscore.isNaN)(nextProps.value));
    var formatStyleChanged = formatStyle !== nextProps.formatStyle;
    var formatterChanged = formatter !== nextProps.formatter;

    if (valueChanged || formatStyleChanged || formatterChanged) {
      if (!this.isTyping) {
        this.setState(this.getStateOnValueReset({
          value: nextProps.value,
          formatStyle: nextProps.formatStyle,
          formatter: nextProps.formatter
        }));
      }
    }
  },
  getStateOnValueReset: function getStateOnValueReset(_ref) {
    var value = _ref.value,
        formatStyle = _ref.formatStyle,
        formatter = _ref.formatter;
    var isValid = this.getValueIsValid({
      value: value
    });
    return {
      isValid: isValid,
      lastValidValue: isValid ? value : null,
      displayedValue: this.getFormattedNumber({
        value: value,
        formatStyle: formatStyle,
        formatter: formatter
      })
    };
  },
  getValueIsValid: function getValueIsValid(_ref2) {
    var value = _ref2.value;
    return value == null || value === '' || !(0, _underscore.isNaN)(_I18n.default.parseNumber(value));
  },
  getFormattedNumber: function getFormattedNumber(_ref3) {
    var value = _ref3.value,
        formatStyle = _ref3.formatStyle,
        formatter = _ref3.formatter;

    if (formatter) {
      var formatterResult = formatter(value);

      if (typeof formatterResult !== 'string') {
        _devLogger.default.warn({
          message: "UIAbstractNumberInput: Expected `formatter(value)` to return a string, but " + ("it returned `" + formatterResult + "`."),
          key: 'UIAbstractNumberInput: bad formatter result'
        });
      } else {
        return formatterResult;
      }
    }

    if (value == null || value === '') {
      return '';
    }

    if (!this.getValueIsValid({
      value: value
    })) {
      return value;
    }

    if (formatStyle === NUMBER_TYPES.PERCENTAGE) {
      return formatPercentage(value);
    }

    return _I18n.default.formatNumber(value);
  },
  getParsedValue: function getParsedValue(_ref4) {
    var rawValue = _ref4.rawValue,
        formatStyle = _ref4.formatStyle,
        parser = _ref4.parser;

    if (parser) {
      var parserResult = parser(rawValue);

      if (parserResult != null && typeof parserResult !== 'number') {
        _devLogger.default.warn({
          message: "UIAbstractNumberInput: Expected `parser(value)` to return a number or null, but " + ("it returned `" + parserResult + "`."),
          key: 'UIAbstractNumberInput: bad parser result'
        });
      } else {
        return parserResult;
      }
    }

    var valueToParse = rawValue; // Ignore % character when parsing input

    if (formatStyle === NUMBER_TYPES.PERCENTAGE) {
      valueToParse = parsePercentage(valueToParse);
    }

    var parsedValue = BLANK_REGEX.test(valueToParse) ? null : _I18n.default.parseNumber(valueToParse);
    return parsedValue;
  },
  handleChange: function handleChange(evt) {
    // Trigger onChange with the numeric value, not the raw string
    var _this$props3 = this.props,
        onChange = _this$props3.onChange,
        value = _this$props3.value,
        formatStyle = _this$props3.formatStyle,
        min = _this$props3.min,
        max = _this$props3.max,
        parser = _this$props3.parser;
    var rawValue = evt.target.value;
    this.setState({
      displayedValue: rawValue
    }); // Prevent formatting while the user is typing

    this.isTyping = true;
    var parsedValue = this.getParsedValue({
      rawValue: rawValue,
      formatStyle: formatStyle,
      parser: parser
    });

    if (value != null && parsedValue == null) {
      (0, _Functions.callIfPossible)(onChange, (0, _SyntheticEvent.default)(null));
      return;
    }

    if (parsedValue !== value && !(0, _underscore.isNaN)(parsedValue)) {
      var fencedMin = min == null ? parsedValue : Math.max(parsedValue, min);
      var fencedValue = max == null ? fencedMin : Math.min(fencedMin, max);
      (0, _Functions.callIfPossible)(onChange, (0, _SyntheticEvent.default)(fencedValue));
    }
  },
  handleBlur: function handleBlur(evt) {
    var onBlur = this.props.onBlur;
    this.handleConfirmedInput();
    this.isTyping = false;
    (0, _Functions.callIfPossible)(onBlur, evt);
  },
  handleFocus: function handleFocus(evt) {
    var onFocus = this.props.onFocus; // If displayedValue is invalid, clear it on focus

    var isValid = this.state.isValid;

    if (!isValid) {
      this.setState({
        isValid: true,
        displayedValue: ''
      });
    }

    (0, _Functions.callIfPossible)(onFocus, evt);
  },
  handleConfirmedInput: function handleConfirmedInput() {
    // Format whatever the user typed for display (e.g. "1234" -> "1,234")
    var _this$props4 = this.props,
        formatStyle = _this$props4.formatStyle,
        formatter = _this$props4.formatter,
        value = _this$props4.value;
    var lastValidValue = this.state.lastValidValue;
    var isValid = this.getValueIsValid({
      value: value
    });
    this.setState({
      isValid: isValid,
      lastValidValue: lastValidValue,
      displayedValue: this.getFormattedNumber({
        value: value,
        formatStyle: formatStyle,
        formatter: formatter
      })
    });
  },
  handleKeyUp: function handleKeyUp(evt) {
    var _this$props5 = this.props,
        onChange = _this$props5.onChange,
        onKeyUp = _this$props5.onKeyUp,
        value = _this$props5.value;
    var lastValidValue = this.state.lastValidValue; // If ESC is pressed, reset to lastValidValue

    if (evt.key === 'Escape' && lastValidValue !== value) {
      (0, _Functions.callIfPossible)(onChange, (0, _SyntheticEvent.default)(lastValidValue));
      this.escKeyUpTriggered = true;
    } // If Enter is pressed, format the value


    if (evt.key === 'Enter' && lastValidValue !== value) {
      this.handleConfirmedInput();
    }

    (0, _Functions.callIfPossible)(onKeyUp, evt);
  },
  render: function render() {
    var _this$props6 = this.props,
        children = _this$props6.children,
        error = _this$props6.error,
        __formatter = _this$props6.formatter,
        __parser = _this$props6.parser,
        __onChange = _this$props6.onChange,
        __value = _this$props6.value,
        __formatStyle = _this$props6.formatStyle,
        rest = (0, _objectWithoutProperties2.default)(_this$props6, ["children", "error", "formatter", "parser", "onChange", "value", "formatStyle"]);
    (0, _invariant.default)(typeof children === 'function', '%s: this.props.children must be a function but got %s', 'UIAbstractNumberInput', children);
    return children((0, _extends2.default)({}, rest, {
      'aria-invalid': typeof error === 'boolean' ? error : !this.state.isValid,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onKeyUp: this.handleKeyUp,
      value: this.state.displayedValue
    }));
  }
});

UIAbstractNumberInput.defaultProps = {
  error: undefined,
  // needed to override UITextInput's default
  formatStyle: undefined
};
var _default = UIAbstractNumberInput;
exports.default = _default;
module.exports = exports.default;